import { typeCreatorV2 } from 'redux/utils/common';

export const SET_CATEGORY: string = typeCreatorV2(
  'ProductFilterReducer',
  'SetCategory'
);

export const SET_AGENTS: string = typeCreatorV2(
  'ProductFilterReducer',
  'SetAgents'
);

export const SET_FILTERS_SELECTION: string = typeCreatorV2(
  'ProductFilterReducer',
  'SetFiltersSelection'
);

export const RESET_STORE: string = typeCreatorV2(
  'ProductFilterReducer',
  'ResetStore'
);

export const SET_CUSTOM_ATTRIBUTES: string = typeCreatorV2(
  'ProductFilterReducer',
  'SetCustomAttributes'
);

export const SET_CITY: string = typeCreatorV2(
  'ProductFilterReducer',
  'SetCity'
);

export const SET_MUNICIPALITY: string = typeCreatorV2(
  'ProductFilterReducer',
  'SetMunicipality'
);

export const SET_SEGMENTS: string = typeCreatorV2(
  'ProductFilterReducer',
  'SetSegments'
);

export const SET_CLIENT_CUSTOMERS: string = typeCreatorV2(
  'ProductFilterReducer',
  'GetClientCustomers'
);

export const GET_LIST_ZONES: string = typeCreatorV2(
  'ProductFilterReducer',
  'GetListZones'
);
